module.exports = {"id":"208277","name":"Olivier Boumal","rating":"73","photo":"./data/images/photos/2/208277.png","club":{"name":"Yokohama F·Marinos","logo":"./data/images/clubs/YokohamaF·Marinos.png"},"positions":["MD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OlivierBoumal0.json
// module id = 3269
// module chunks = 0